import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.548 12.715a.777.777 0 01-.547-.223L1.226 8.759a.76.76 0 010-1.083.78.78 0 011.095 0l3.227 3.19 7.73-7.642a.78.78 0 011.095 0 .758.758 0 010 1.083l-8.277 8.185a.777.777 0 01-.548.224" fill="#09AA5C" /></svg>);